import React from "react"
import { View, Text, ImageBackground } from "react-native"
import { getImagePath, maxStringLength } from "../services/CommonUtils"

import AppTheme from "../../AppTheme"
import AppStyles from "../../AppStyles"
import Colors from "../constants/AppColors"

import PaginationItem from "./Carousel/Pagination";

export const AdPosterView = (posterData, index, scallingFactor, viewWidth, viewHeight, callback) => {
    const titleConfing = posterData[index]['uiConfiguration'] &&
        posterData[index]['uiConfiguration']['title'] && posterData[index]['title'] ? {
        ...posterData[index]['uiConfiguration']['title'],
        hint: posterData[index]['title']
    } : posterData[index]['uiConfiguration'] &&
    posterData[index]['uiConfiguration']['title'] ? posterData[index]['uiConfiguration']['title'] : null; 
    const descriptionConfig = posterData[index]['uiConfiguration'] &&
        posterData[index]['uiConfiguration']['description'] && posterData[index]['description'] ? {
        ...posterData[index]['uiConfiguration']['description'],
        hint: maxStringLength(
            posterData[index]['description'],
            posterData[index]['uiConfiguration']['description']['maxLength'])
    } : posterData[index]['uiConfiguration'] 
    && posterData[index]['uiConfiguration']['description'] ? 
    posterData[index]['uiConfiguration']['description']: null

    let cardContentAlignment = AppStyles.alignCenter
    if (titleConfing && titleConfing['vbias'])
        cardContentAlignment = {
        paddingTop: titleConfing['vbias'] * viewHeight - 16,
        alignContent: titleConfing.alignment,
        // justifyContent: titleConfing.alignment,
        alignSelf: titleConfing.alignment,
        alignItems: titleConfing.alignment,
    }
    console.log('cardContentAlignment', cardContentAlignment);
    

    return (<ImageBackground loadingIndicatorSource={{
        uri: getImagePath('/images/image_loader.gif')
    }} imageStyle={{ borderRadius: 4 }} style={[cardContentAlignment, {
        width: viewWidth, height: viewHeight,
        paddingHorizontal: 16, paddingVertical: 16
    }]} source={{ uri: posterData[index]['imageUrl'] }}>
        {!!titleConfing && <Text style={{
            color: titleConfing.color,
            fontSize: titleConfing.fontSize * scallingFactor,
            textAlign: titleConfing.alignment ?? "center",
            width: titleConfing.widthPct * viewWidth * scallingFactor
        }}>{titleConfing['hint']}</Text>}
        {!!descriptionConfig && <Text style={{
            marginTop: 8,
            color: descriptionConfig.color,
            fontSize: descriptionConfig.fontSize * scallingFactor,
            textAlign: descriptionConfig.alignment ?? "center",
            width: descriptionConfig.widthPct * viewWidth * scallingFactor
        }}>{descriptionConfig['hint']}</Text>}
    </ImageBackground>)
}

export const AdPosterPaginationView = (carouselData, progressValue) => {
    return (<View style={[AppStyles.flexRowCenter, {
        width: AppTheme.appWidth, marginTop: 8
    }]}>{carouselData.map((data, index) => {
        return (<PaginationItem key={index} index={index}
            width={4} height={4}
            animValue={progressValue} length={carouselData.length}
            viewStyle={{ backgroundColor: Colors.grey.bg }}
            highlightedViewStyle={{ backgroundColor: Colors.primary }} />
        );
    })}</View>)
}